import Vue from 'vue';
import Antd from 'ant-design-vue';
import App from './App.vue';
import router from './router';
import store, { UPDATE_EXPIRY, LEAVE_SESSION } from './store';
import './styles/index.less';

Vue.use(Antd);
Vue.config.productionTip = false;

// Leave session on token expiry
store.subscribe((mutation, state) => {
  if (mutation.type === UPDATE_EXPIRY && state.timeRemaining && state.timeRemaining < 0) {
    store.dispatch(LEAVE_SESSION);
    router.push({ name: 'home' });
  }
});

Vue.filter('capitalize', function(value: string) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
